import React from 'react';
export const Base44Logo = () => /*#__PURE__*/React.createElement("svg", {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("path", {
  d: "M13.7105 12C13.7988 12 13.8836 12.0351 13.946 12.0976L14.338 12.49C14.4302 12.5822 14.4425 12.728 14.3637 12.8319C12.9041 14.7568 10.5936 16 7.99299 16C5.38912 16 3.0761 14.7538 1.61675 12.8248C1.53814 12.7209 1.55056 12.5753 1.64264 12.4831L2.02787 12.0976C2.09033 12.0351 2.17503 12 2.26335 12H13.7105Z",
  fill: "#FF6A00"
}), /*#__PURE__*/React.createElement("path", {
  d: "M7.99299 0C12.4074 0 15.986 3.58172 15.986 8C15.986 8.28991 15.9704 8.5762 15.9404 8.85812C15.9309 8.9467 15.8905 9.02887 15.8275 9.09186L15.0373 9.88283C14.9624 9.95785 14.8607 10 14.7547 10H1.23127C1.12528 10 1.02363 9.95786 0.948677 9.88284L0.158388 9.09186C0.0954516 9.02887 0.0549808 8.94669 0.0455364 8.85811C0.0154781 8.57619 0 8.2899 0 8C0 3.58172 3.57858 0 7.99299 0Z",
  fill: "#FF6A00"
}));
//# sourceMappingURL=Base44Logo.js.map